import React from 'react';
import Switch from 'react-switch'
import {QueryRenderer , graphql} from 'react-relay'
import environment from '../../RelayEnvironment'
import Tag from '../Tags/Tag';
import '../../css/components/AreaFilterParent/AreaFilterParent.css';

export default class AreaFilterParent extends React.Component {
constructor(props){
 super(props);

 this.state = {
       displayMenu: false,
       isSearchingUsAreas: true,
       isSearchingMyAreas: false,
       SearchAreaText:"",
      };

  this.showDropdownMenu = this.showDropdownMenu.bind(this);
  this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
// console.log("my area drop down props-->",props)
};

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ displayMenu: true }, () => {
    });
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
    });

  }

    checkAreaSelected = (event) => {
        if(this.props.disabled === true) {
            return;
        }
        if(this.props.savedAreaIdSelected == null || this.props.savedAreaIdSelected === "") {
            this.props.onFilterByAreaChange();
            event.stopPropagation();
        }
    }
    
    checkAreaSelected2 = (event) => {
        if(this.props.disabled === true) {
            return;
        }
        if(this.props.savedAreaIdSelected == null || this.props.savedAreaIdSelected === "") {
            this.props.onFilterByAreaChange();
            event.stopPropagation();
        } else {
            this.props.onFilterByAreaChange();
        }
    }

    handleFilterByAreaChange = (checked, event, id) => {
        if(this.props.disabled === true) {
            return;
        }
        this.props.onFilterByAreaChange();
    }
    
  render() {
      return (
          <div className="areaFilterParent">
              <div>
                <div className="areaFilterParent-switch">
                    <div className="areaFilterParent-switch-title">
                        <span>Show My<br/> Area Only</span>
                    </div>
                    <div className="areaFilterParent-switch-control" onClick={this.checkAreaSelected}>
                        <Switch
                            onChange={this.handleFilterByAreaChange}
                            checked={this.props.filterByArea === true}
                            disabled={this.props.disabled === true || this.props.savedAreaIdSelected == null || this.props.savedAreaIdSelected === ""}
                            className='react-switch'
                            id='toggleFilterByArea'
                            height={18}
                            width={35}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor='#00939d'
                            onHandleColor='#fff'
                            aria-label='Show my area only'
                        />
                    </div>
                    <div className="areaFilterParent-switch-status" onClick={this.checkAreaSelected2}>
                        <span>{this.props.filterByArea === true ? "ON" : "OFF"}</span>
                    </div>
                    <div className="areaFilterParent-geotag">
                    {(this.props.savedAreaIdSelected != null && this.props.savedAreaIdSelected !== "") ? 
                        <QueryRenderer
                          environment={environment}
                          query={graphql`
                              query AreaFilterParentSelectedAreaQuery($input: ID!) {
                                savedArea(id: $input) {
                                      id
                                      jsonid
                                      name
                                    }
                              }
                          `}
                          variables={{ "input": this.props.savedAreaIdSelected }}
                          render={({error, props}) => {
                              if (error) {
                                  console.error(error);
                                  return <div>Error!</div>;
                              }
                              if (!props || !props.savedArea){
                                  return <div/>
                              }
                              return (
                                <Tag {...this.props} data={props.savedArea.name} />
                              );
                          }} /> : null }
                    </div>
                </div>
            </div>
        </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AreaFilterParent/AreaFilterParent.js